import { createContext, useContext, useState, useCallback } from "react";
import { DEFAULTS, sanitizeSettings } from "../config/wheelConfig";

const WheelSettingsContext = createContext();

export const WheelSettingsProvider = ({ children }) => {
  const [settings, setSettingsRaw] = useState(() => sanitizeSettings(DEFAULTS));

  const setSettings = useCallback((update) => {
    setSettingsRaw((prev) => sanitizeSettings({ ...prev, ...update }));
  }, []);

  const resetSettings = useCallback(() => {
    setSettingsRaw(sanitizeSettings(DEFAULTS));
  }, []);

  return (
    <WheelSettingsContext.Provider value={{ settings, setSettings, resetSettings }}>
      {children}
    </WheelSettingsContext.Provider>
  );
};

export const useWheelSettings = () => useContext(WheelSettingsContext);
